import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export interface RelatedPost {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
}

export const RelatedReads = ({
  posts,
  heading = "Related Reads",
}: {
  posts: RelatedPost[];
  heading?: string;
}) => {
  if (!posts.length) return null;
  return (
    <section className="section-padding bg-background border-t border-border/40">
      <div className="container-narrow mx-auto px-4 md:px-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">
          {heading}
        </h2>
        <div className="grid gap-6 md:grid-cols-3">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              className="group block bg-card rounded-2xl overflow-hidden shadow-soft hover:shadow-elevated transition-shadow"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors leading-tight">
                  {p.title}
                </h3>
                <p className="text-muted-foreground text-sm line-clamp-2 mb-3">
                  {p.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-primary text-sm font-medium">
                  Read more <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
